import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { FineDetailsPublicResponse } from "api"
import Image from "next/image"
import { Dispatch, SetStateAction } from "react"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import { ErrorType } from "../Payment"
import Form from "./Form"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 24px;
    flex-direction: row;
  }
`

const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 24px;
  }
`

const StyledSubTitle = styled(Typography)<{ component?: React.ElementType }>`
  margin: 0px;
`

export default function FirstStage({
  toSecondStage,
  setIsLoading,
  setData,
  stepData,
  setError,
}: {
  toSecondStage: () => void
  setIsLoading: Dispatch<SetStateAction<boolean>>
  setData: Dispatch<SetStateAction<FineDetailsPublicResponse | undefined>>
  stepData: {
    icon: string
    title: string
    subTitle: string
  }
  setError: Dispatch<SetStateAction<ErrorType | undefined>>
}) {
  return (
    <StyledLayout>
      <TextBox>
        <Image
          src={getUmbracoMediaUrl(stepData?.icon)}
          width={80}
          height={80}
          alt="icon"
        />
        <TextDiv>
          <Typography variant="h2" component={"h1"}>
            {stepData?.title}
          </Typography>
          <Typography variant="body1" component={"h2"}>
            {stepData?.subTitle}
          </Typography>
        </TextDiv>
      </TextBox>
      <Form
        setIsLoading={setIsLoading}
        toSecondStage={toSecondStage}
        setData={setData}
        setError={setError}
      />
    </StyledLayout>
  )
}
